// extracted by mini-css-extract-plugin
export default {"plate":"oIONPc6ikfI_Y9iJmLrU"};